import {
  thumbnail1,
  thumbnail2,
  thumbnail3,
  thumbnail4,
  imageProduct1,
  imageProduct2,
  imageProduct3,
  imageProduct4,
} from "../assets/images";

export const sneakers = [
  {
    thumbnail: thumbnail1,
    bigsneaker: imageProduct1,
    id: 1,
  },
  {
    thumbnail: thumbnail2,
    bigsneaker: imageProduct2,
    id: 2,
  },
  {
    thumbnail: thumbnail3,
    bigsneaker: imageProduct3,
    id: 3,
  },
  {
    thumbnail: thumbnail4,
    bigsneaker: imageProduct4,
    id: 4,
  },
];

export const navLinks = [
  { href: "#Collections", label: "Collections", id: 1 },
  { href: "#Men", label: "Men", id: 2 },
  { href: "#Women", label: "Women", id: 3 },
  { href: "#About", label: "About", id: 4 },
  { href: "#Contact", label: "Contact", id: 5 },
];
